import { ArrowBack } from "@mui/icons-material";
import { Box, Button, IconButton, Paper, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import InputWithHiddenIcon from "./InputWithHiddenIcon";
import { useUpdateAppConfig } from "hooks";
import { useState } from "react";
import { isEqual } from "lodash";

const AppConfig = ({ appName, defaultConfig, onBack }) => {
  const { t: getLabel } = useTranslation();
  const { updateAppConfigAsync } = useUpdateAppConfig();

  const [config, setConfig] = useState(defaultConfig);
  const [isCallingApi, setIsCallingApi] = useState(false);

  const handleResetConfig = () => setConfig(defaultConfig);

  const handleSubmit = async () => {
    setIsCallingApi(true);
    await updateAppConfigAsync(config);
    setIsCallingApi(false);
  };

  const handleChangeContent = e => {
    const fieldName = e.target.name;
    const value = e.target.value;

    setConfig(prev => ({ ...prev, [fieldName]: value }));
  };

  const handleChangeHidden = e => {
    const fieldName = e.currentTarget?.name;
    const currentValue = config[fieldName];

    setConfig(prev => ({ ...prev, [fieldName]: Boolean(currentValue) ? 0 : 1 }));
  };

  const isDisableAction =
    false === Boolean((config.title || "").trim().length > 0 && !isEqual(defaultConfig, config)) || isCallingApi;

  return (
    <Paper sx={{ width: "100%", height: "calc(100% - 75px)", px: 2, py: 4 }}>
      <Stack width="100%" direction="row" alignItems="flex-start" justifyContent="space-between" mb={1}>
        <Stack direction="row" alignItems="flex-start" spacing={1}>
          <IconButton sx={{ color: "#000000" }} edge="start" onClick={onBack}>
            <ArrowBack />
          </IconButton>
          <Box>
            <Typography fontWeight="bold" fontSize={20}>{`${getLabel("TXT_CONFIG_APP")} ${appName}`}</Typography>
            <Typography fontStyle="italic" fontSize={12}>
              {`*Cấu hình sẽ áp dụng cho màn hình khóa, màn hình danh sách ứng dụng, màn hình chính, màn hình thông tin sản phẩm của ứng dụng ${appName}`}
            </Typography>
          </Box>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Button variant="contained" disabled={isDisableAction} onClick={handleResetConfig}>
            {getLabel("L_CANCEL")}
          </Button>
          <Button variant="contained" disabled={isDisableAction} onClick={handleSubmit}>
            {getLabel("TXT_SAVE_CONFIG")}
          </Button>
        </Stack>
      </Stack>

      <Stack p={2} spacing={2}>
        <Typography fontWeight={700} fontSize={16}>
          Tiêu đề ứng dụng
        </Typography>

        <Stack spacing={2}>
          <InputWithHiddenIcon
            label="Tiêu đề (*)"
            isHidden={Boolean(config.title_hidden_f)}
            TextFieldProps={{
              name: "title",
              value: config.title,
              inputProps: { required: true, maxLength: 50 },
              onChange: handleChangeContent,
            }}
            IconButtonProps={{ name: "title_hidden_f", disabled: true, onClick: handleChangeHidden }}
          />
          <InputWithHiddenIcon
            label="Tiêu đề phụ"
            isHidden={Boolean(config.subtitle_hidden_f)}
            TextFieldProps={{
              name: "subtitle",
              value: config.subtitle,
              inputProps: { maxLength: 50 },
              onChange: handleChangeContent,
            }}
            IconButtonProps={{ name: "subtitle_hidden_f", onClick: handleChangeHidden }}
          />
        </Stack>
      </Stack>
    </Paper>
  );
};

export default AppConfig;
